export default {
  'realtime_users_title': '实时用户',
  'realtime_users_time_zone': '时区',
  'realtime_users_tab1': '用户',
  'realtime_users_tab2': '国家/区域/区服',
  'realtime_users_tab3': '异动分析', // 实时国家异动对比  //第一期暂时不做中文版本
  'realtime_users_tab4': '数据下载',
  'realtime_users_country_platform': '区域/平台',

  'realtime_users_refresh_text': '每5分钟自动刷新',

  // 卡片
  'realtime_users_new_users_card_title': '新进用户',
  'realtime_users_active_users_card_title': '活跃用户',
  'realtime_users_online_users_card_title': '在线用户',
  'realtime_users_d2_card_title': '新进次留(T-1)',
  'realtime_users_d3_card_title': '新进3留(T-2)',
  'realtime_users_d7_card_title': '新进7留(T-6)',

  'realtime_users_d2_card_title_pc': '新进次留(T-1)',
  'realtime_users_d3_card_title_pc': '新进2留(T-2)',
  'realtime_users_d7_card_title_pc': '新进7留(T-7)',

  'realtime_users_new_tab': '新进用户',
  'realtime_users_active_tab': '活跃用户',
  'realtime_users_online_tab': '在线用户',
  'realtime_users_ccu_tab': '在线用户',
  'realtime_users_d2_tab': '新进次留(T-1)',
  'realtime_users_d3_tab': '新进3留(T-2)',
  'realtime_users_d7_tab': '新进7留(T-6)',

  'realtime_users_d2_tab_pc': '新进次留(T-1)',
  'realtime_users_d3_tab_pc': '新进2留(T-2)',
  'realtime_users_d7_tab_pc': '新进7留(T-7)',

  'realtime_users_new_title': '新进用户',
  'realtime_users_active_title': '活跃用户',
  'realtime_users_online_title': '在线用户',
  'realtime_users_d2_title': '新进次留(T-1)',
  'realtime_users_d3_title': '新进3留(T-2)',
  'realtime_users_d7_title': '新进7留(T-6)',

  'realtime_users_d2_title_pc': '新进次留(T-1)',
  'realtime_users_d3_title_pc': '新进2留(T-2)',
  'realtime_users_d7_title_pc': '新进7留(T-7)',

  'realtime_by_country_statistical_time': '统计时间',
  'realtime_by_country_register_date': '注册时间',
  'realtime_by_country_table_time': '时间',
  'realtime_by_country_table_zone': '区服',
  'realtime_by_country_table_region': '区域',
  'realtime_by_country_table_country': '国家',
  'realtime_by_country_table_system': '平台',
  'realtime_by_country_table_channel': '渠道',
  'realtime_by_country_table_category': '产品类型',
  'realtime_by_country_table_product': '产品',
  'realtime_by_country_table_language': '语言',
  'realtime_by_country_table_ad_format': '广告类型',
  'realtime_by_country_table_ua_network': '买量渠道',
  'realtime_by_country_table_new_users': '新进用户',
  'realtime_by_country_table_active_users': '活跃用户',
  'realtime_by_country_table_online_users': '在线用户',
  'realtime_by_country_table_d2': '次留',
  'realtime_by_country_table_d3': '3留',
  'realtime_by_country_table_d7': '7留',

  'realtime_by_country_table_d2_pc': '次留',
  'realtime_by_country_table_d3_pc': '2留',
  'realtime_by_country_table_d7_pc': '7留',

  'realtime_by_country_new_tab': '新进用户',
  'realtime_by_country_active_tab': '活跃用户',
  'realtime_by_country_online_tab': '在线用户',
  'realtime_by_country_d2_tab': '新进次留(T-1)',
  'realtime_by_country_d3_tab': '新进3留(T-2)',
  'realtime_by_country_d7_tab': '新进7留(T-6)',

  'realtime_by_country_new_title': '新进用户',
  'realtime_by_country_active_title': '活跃用户',
  'realtime_by_country_online_title': '在线用户',
  'realtime_by_country_d2_title': '新进次留(T-1)',
  'realtime_by_country_d3_title': '新进3留(T-2)',
  'realtime_by_country_d7_title': '新进7留(T-6)',

  'realtime_by_platform_by_country': '分国家',
  'realtime_by_platform_by_region': '分区域',
  'realtime_by_platform_by_platform': '分平台',

  'realtime_register_date': '注册日期',
  'realtime_total_new': '新进总数',

  // download
  'realtime_download_table_time': '时间',
  'realtime_download_table_new': '新进用户',
  'realtime_download_table_dau': '日活跃',
  'realtime_download_table_online': '在线用户',
  'realtime_download_users_title': '用户数据总体表现',
  'realtime_download_retention_title': '留存整体表现',

  'realtime_metrics': '分维度查看top5及others实时指标数据。',

  // change analysis
  'realtime_change_analysis_allCountry': 'All Countries',
  'realtime_change_analysis_keyCountries': 'Key Countries',
  'realtime_change_analysis_topChangeNewTitle': 'Top Change - Realtime Daily Accumulated New Users (5 min)',
  'realtime_change_analysis_country': 'Country',
  'realtime_change_analysis_new': 'New',
  'realtime_change_analysis_change': 'Change%',
  'realtime_change_analysis_topChangeActiveTitle': 'Top Change - Realtime Daily Accumulated Active Users (5 min)',
  'realtime_change_analysis_topChangeD2Title': 'Top Change - Retention D2 (1 hour)',
  'realtime_change_analysis_topChangeD3Title': 'Top Change - Retention D3 (1 hour)',
  'realtime_change_analysis_topChangeD7Title': 'Top Change - Retention D7 (1 hour)',

  // 指标卡片解释
  'realtime_metrics_card_title': '实时关键指标',
  'realtime_metrics_card_modal_title': '实时关键指标释义',
  'realtime_metrics_card_modal_table_header_metrics': '指标',
  'realtime_metrics_card_modal_table_header_explanation': '指标释义',
  'realtime_metrics_card_modal_table_new_users': '新进用户',
  'realtime_metrics_card_modal_table_new_users_explain': '取统计日当天0点到当前统计时间点累计新进用户数。取 Play Register表 vopenid 的去重数。',
  'realtime_metrics_card_modal_table_active_users': '活跃用户',
  'realtime_metrics_card_modal_table_active_users_explain': '取统计日当天0点到当前统计时间点累计活跃用户数。取 Play Login 表vopenid 的去重数。',
  'realtime_metrics_card_modal_table_online_users': '在线用户',
  'realtime_metrics_card_modal_table_online_users_explain': '取当前统计时间点在线用户数。',
  'realtime_metrics_card_modal_table_d2': '新进次留',
  'realtime_metrics_card_modal_table_d2_explain': '取统计日T-1注册人数在统计日当天0点到当前统计时间点所活跃过的用户数/统计日T-1注册人数。',
  'realtime_metrics_card_modal_table_d3': '新进3留',
  'realtime_metrics_card_modal_table_d3_explain': '取统计日T-2注册人数在统计日当天0点到当前统计时间点所活跃过的用户数/统计日T-2注册人数。',
  'realtime_metrics_card_modal_table_d7': '新进7留',
  'realtime_metrics_card_modal_table_d7_explain': '取统计日T-6注册人数在统计日当天0点到当前统计时间点所活跃过的用户数/统计日T-6注册人数。',
  'realtime_metrics_card_modal_table_dod': '日环比',
  'realtime_metrics_card_modal_table_dod_explain_1': '以T为统计日日期，日环比为统计日当前时点的累计数据减去昨天同一时点的累计数据除以昨天同一时点的累计数据；',
  'realtime_metrics_card_modal_table_dod_explain_2': '以新进用户为例：日环比=新进用户(T)-新进用户(T-1)/新进用户(T-1)',
  'realtime_metrics_card_modal_table_sdlw': '上周同期',
  'realtime_metrics_card_modal_table_sdlw_explain_1': '以T为统计日日期，上周同期指周同比，为统计日当前时点的累计数据减去上周同一时点的累计数据除以上周同一时点的累计数据；',
  'realtime_metrics_card_modal_table_sdlw_explain_2': '以新进用户为例：周同比=新进用户(T)-新进用户(T-7)/新进用户(T-7)',

  'realtime_metrics_card_modal_table_d2_explain_pc': '次留=xx注册日期第1天存留用户数/xx注册日期新注册用户数，注册日是第0天',

  'realtime_metrics_card_modal_table_d3_explain_pc': '2留=xx注册日期第2天存留用户数/xx注册日期新注册用户数，注册日是第0天',

  'realtime_metrics_card_modal_table_d7_explain_pc': '7留=xx注册日期第7天存留用户数/xx注册日期新注册用户数，注册日是第0天',


  
  // 异动
  'realtime_analysis': '异动分析',
  'realtime_analysis_All_Countries': '汇总',
  'realtime_analysis_Key_country': '关注国家',

  'realtime_analysis_Country': '国家',
  'realtime_analysis_New': '新进用户',
  'realtime_analysis_Change': '变化率',
  'realtime_analysis_Change_Value': '变化',
  'realtime_analysis_Change_Of_New': '新进用户变化',
  'realtime_analysis_Active': '活跃用户',
  'realtime_analysis_Online': '在线用户',
  'realtime_analysis_D2': '次留',
  'realtime_analysis_D3': '3留',
  'realtime_analysis_D7': '7留',

  'realtime_analysis_D2_pc': '次留',
  'realtime_analysis_D3_pc': '2留',
  'realtime_analysis_D7_pc': '7留',

  'realtime_analysis_Title_1': 'Top20新进用户变化国家（5min）',
  'realtime_analysis_Title_2': 'Top20活跃用户变化国家（5min）',
  'realtime_analysis_Title_3': 'Top20在线用户变化国家（5min）',
  'realtime_analysis_Title_4': 'Top20次留变化国家（1小时）',
  'realtime_analysis_Title_5': 'Top20三留变化国家（1小时）',
  'realtime_analysis_Title_6': 'Top20七留变化国家（1小时）',

  'realtime_analysis_Title_4_pc': 'Top20次留变化国家（1小时）',
  'realtime_analysis_Title_5_pc': 'Top20二留变化国家（1小时）',
  'realtime_analysis_Title_6_pc': 'Top20七留变化国家（1小时）',

  'realtime_analysis_Title_4_pc_base': 'Top20 D1留存变化国家（1小时）',
  'realtime_analysis_Title_5_pc_base': 'Top20 D2留存变化国家（1小时）',
  'realtime_analysis_Title_6_pc_base': 'Top20 D7留存变化国家（1小时）',

  'realtime_analysis_table_title_new_left': '分国家异动数据(左侧表格)-新进',
  'realtime_analysis_table_title_active_left': '分国家异动数据(左侧表格)-活跃',
  'realtime_analysis_table_title_online_left': '分国家异动数据(左侧表格)-在线用户',
  'realtime_analysis_table_title_d2_left': '分国家异动数据(左侧表格)-次留',
  'realtime_analysis_table_title_d3_left': '分国家异动数据(左侧表格)-3留',
  'realtime_analysis_table_title_d7_left': '分国家异动数据(左侧表格)-7留',

  'realtime_analysis_table_title_new_right_5min': '5min-实时明细数据(右侧图表)-新进',
  'realtime_analysis_table_title_active_right_5min': '5min-实时明细数据(右侧图表)-活跃',
  'realtime_analysis_table_title_online_right_5min': '5min-实时明细数据(右侧图表)-在线用户',
  'realtime_analysis_table_title_new_right_1hour': '1hour-实时明细数据(右侧图表)-新进',
  'realtime_analysis_table_title_active_right_1hour': '1hour-实时明细数据(右侧图表)-活跃',
  'realtime_analysis_table_title_online_right_1hour': '1hour-实时明细数据(右侧图表)-在线用户',
  'realtime_analysis_table_title_d2_right_1hour': '1hour-实时明细数据(右侧图表)-次留',
  'realtime_analysis_table_title_d3_right_1hour': '1hour-实时明细数据(右侧图表)-3留',
  'realtime_analysis_table_title_d7_right_1hour': '1hour-实时明细数据(右侧图表)-7留',

  'realtime_analysis_Register_Date': '注册日',
  'realtime_analysis_Statistical_Time': '统计时间',
  'realtime_analysis_Time': '时间',
  'realtime_analysis_Global': '汇总',
  'realtime_analysis_Total': '汇总',
  'realtime_analysis_.Change': '变化率',
  'realtime_analysis_bubbleText': '最多只能选择10项，请取消之前选项后重新勾选。',
  'realtime_analysis_tabBubbleText': '关注国家是游戏所重点关注的国家，游戏业务方可直接提供国家列表。',

  // v2.15版本新增需求 右上角的切换按钮
  'realtime_analysis_Same_Trend': '和汇总相同变化趋势',
  'realtime_analysis_Same_Trend_Total': '和汇总相同变化趋势',
  'realtime_analysis_Opposite_Trend': '和汇总相反变化趋势',
  'realtime_analysis_Opposite_Trend_Total': '和汇总相反变化趋势',
  'realtime_analysis_All_Trend': '所有变化趋势',


  'realtime_analysis_trendTips': '默认显示全部变化趋势的国家，可以切换为相同趋势/相反趋势的国家。',
};
